import { render, staticRenderFns } from "./WeSlogan.vue?vue&type=template&id=b0651580&"
import script from "./WeSlogan.vue?vue&type=script&lang=ts&"
export * from "./WeSlogan.vue?vue&type=script&lang=ts&"
import style0 from "./WeSlogan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports